import { ArrowUpRight } from "lucide-react";

const products = [
  {
    name: "Metrifly",
    url: "https://metrifly.com",
    host: "metrifly.com",
    live: true,
    description:
      "Portfolio tracking and Australian tax reporting for investors. Trades, dividends, and capital gains from 100+ brokers, reconciled automatically.",
    tags: ["Multi-broker aggregation", "CGT & franking credits", "MyTax export"],
  },
  {
    name: "DeskNova",
    url: "https://desknova.io",
    host: "desknova.io",
    live: false,
    description:
      "AI-powered omnichannel support desk. Every customer conversation in one inbox, with an AI copilot grounded in your docs — not the open web.",
    tags: ["Unified inbox", "AI copilot", "Flat per-agent pricing"],
  },
];

const Products = () => (
  <section id="products" className="scroll-mt-16 py-24">
    <div className="mx-auto max-w-6xl px-6">
      <p className="font-mono text-xs uppercase tracking-widest text-muted">
        What we&rsquo;ve shipped
      </p>
      <h2 className="mt-3 text-3xl font-semibold tracking-tight md:text-4xl">
        Products
      </h2>
      <div className="mt-12 grid gap-6 md:grid-cols-2">
        {products.map((product) => (
          <a
            key={product.name}
            href={product.url}
            target="_blank"
            rel="noopener noreferrer"
            className="group flex flex-col rounded-lg border border-line bg-surface p-8 transition-colors hover:border-accent/40"
          >
            <div className="flex items-start justify-between">
              <h3 className="text-2xl font-semibold tracking-tight">
                {product.name}
              </h3>
              {product.live ? (
                <span className="inline-flex items-center gap-2 rounded-full bg-accent-dim px-3 py-1 font-mono text-xs uppercase tracking-widest text-accent">
                  <span className="h-1.5 w-1.5 rounded-full bg-accent" />
                  Live
                </span>
              ) : (
                <span className="rounded-full border border-line px-3 py-1 font-mono text-xs uppercase tracking-widest text-muted">
                  Coming soon
                </span>
              )}
            </div>
            <p className="mt-4 text-muted">{product.description}</p>
            <div className="mt-6 flex flex-wrap gap-2">
              {product.tags.map((tag) => (
                <span
                  key={tag}
                  className="rounded border border-line px-2.5 py-1 font-mono text-xs text-muted"
                >
                  {tag}
                </span>
              ))}
            </div>
            <span className="mt-8 inline-flex items-center gap-1 font-mono text-sm text-muted transition-colors group-hover:text-accent">
              {product.host}
              <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </span>
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default Products;
